export const inferSchemeFromDriverGradeName = (driverGradeName) => {
    const name = driverGradeName.toLowerCase();

    if (name.includes('bch')) {
        return 'bch';
    } else if (name.includes('sal')) {
        return 'salsac';
    } else if (name.includes('eco')) {
        return 'ecoamaps';
    }

    return false;
}

